import { PLAY_STORE_URL } from "./store";

export { PLAY_STORE_URL };

export const SITE_NAME = "Treasure";
export const COMPANY_NAME = "Weps Technology";
export const COMPANY_ADDRESS =
  "H.No. 383, Muzaffarabad, Saharanpur, Uttar Pradesh, India – 247129";
export const DEFAULT_DESCRIPTION =
  "Track income and expenses on Android with Treasure. Free money management for students with pocket money and young professionals on their first salary.";
export const OG_IMAGE = "/treasure-og-image.png";
export const LOGO_PATH = "/logo512.png";
export const FALLBACK_SITE_URL = "https://treasuremoney.in";

/** Official profiles that should appear as Organization.sameAs. Add LinkedIn/X/Instagram when they exist. */
export const SAME_AS = [PLAY_STORE_URL];

export const getSiteUrl = () => {
  if (typeof process !== "undefined" && process.env?.REACT_APP_SITE_URL) {
    return process.env.REACT_APP_SITE_URL.replace(/\/$/, "");
  }
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }
  return FALLBACK_SITE_URL;
};
